// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 我的今日值班模板ID列表 GET /api/template_sign_duty/my_today */
export async function getMyTodayDuty(options?: { [key: string]: any }) {
    return request<API.Response<number[]>>('/api/template_sign_duty/my_today', {
        method: 'GET',
        ...(options || {}),
    });
}

/** 保存今日值班配置（覆盖式） POST /api/template_sign_duty/save */
export async function saveTodayDuty(
    data: DutyAPI.SaveTodayDutyParams,
    options?: { [key: string]: any },
) {
    return request<API.Response<void>>('/api/template_sign_duty/save', {
        method: 'POST',
        data,
        ...(options || {}),
    });
}
